import React, { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import Logo from './Logo';
import { useLanguage } from '../contexts/language';
import { ADMIN_PANEL_AFTER } from '../../config/config';
import LanguageSelector from './LanguageSelector';
import FontSizeSelector from './FontSizeSelector';

const NavbarLogoMenu = ({ showControlsMenu, setShowControlsMenu }) => {
  const { content } = useLanguage();

  const [showAdmin, setShowAdmin] = useState(0);

  const openAdminDialog = () => {
    setShowAdmin((prev) => prev + 1);
    setTimeout(() => {
      setShowAdmin((prev) => (prev < ADMIN_PANEL_AFTER ? 0 : prev));
    }, ADMIN_PANEL_AFTER * 1000);
  };

  React.useEffect(() => {
    setShowControlsMenu(showAdmin >= ADMIN_PANEL_AFTER);
  }, [showAdmin]);

  React.useEffect(() => {
    if (!showControlsMenu) {
      setShowAdmin(0);
    }
  }, [showControlsMenu]);

  return (
    <>
      <Box position="absolute" top={0} left={0} textAlign="left">
        <FontSizeSelector color="secondary" />
      </Box>
      <Box position="absolute" top={0} right={0} textAlign="right">
        <LanguageSelector />
      </Box>
      <Box mt="4vh" mb="2vh" textAlign="center">
        <Button
          onClick={openAdminDialog}
          aria-haspopup="menu"
          aria-expanded={showAdmin >= ADMIN_PANEL_AFTER}
          aria-label={content('aria_open_controls_menu')}
        >
          <Logo />
        </Button>
      </Box>
    </>
  );
};

export default NavbarLogoMenu;
